var constants = {};

// Breakpoints
constants.breakpointXs = 480;
constants.breakpointSm = 801;
constants.breakpointMd = 1080;
constants.breakpointLg = 1180;

// Debounce values
constants.debounceResize = 75;

//RegEx
constants.regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

//
module.exports = constants;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-constants.js